import { Component, ReactNode } from 'react';

import {
  AdminPortalError,
  NycDoeError,
  Error as ErrorComponent,
} from 'shared/ui/errors';
import { ERROR_MESSAGE } from 'shared/config/constants';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  resetErrorBoundary = () => {
    this.setState({
      hasError: false,
      error: null,
    });
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      switch (error?.message) {
        case ERROR_MESSAGE.PROGRAMS_NOT_SETUP:
          return <NycDoeError />;
        case ERROR_MESSAGE.PROGRAMS_SETUP:
          return <AdminPortalError />;
        case ERROR_MESSAGE.ASSIGNMENTS_ERROR:
          return (
            <ErrorComponent
              resetError={this.resetErrorBoundary}
              isAssignmentsError
            />
          );
        default:
          return <ErrorComponent />;
      }
    }

    return children;
  }
}

export default ErrorBoundary;
